//@flow
import {useCallback} from 'react';
import {useSelector, shallowEqual} from 'react-redux';

import {actions as bulkEditActions} from '../duck';

import {useActions} from '../../../utils/globalStore';
import {useProductFilter} from './productFilters';

import type {RootState} from '../..';
import type {VariantIds} from '../constants';

const tableActiveCellSelector = (state: RootState) =>
  state.bulkEdit.tableActiveCells;

export function useActiveCellsId(): string[] {
  const cellActiveId = useSelector(tableActiveCellSelector);

  return cellActiveId;
}

export function useActiveCellId(id: VariantIds): boolean {
  const cells = useActiveCellsId();

  return cells.includes(id);
}

const toggleActiveCell = bulkEditActions.toggleTableCellId;

export function useToggleActiveCell() {
  const toggleCell = useActions(toggleActiveCell);

  return toggleCell;
}

const addWholesalePriceCell = bulkEditActions.addWholesalePriceCell;

export function useAddWholesalePriceCell() {
  const addWholesalePrice = useActions(addWholesalePriceCell);

  return addWholesalePrice;
}

const productSelector = (state: RootState) => ({
  products: state.bulkEdit.products,
  isFetchingProducts: state.bulkEdit.isFetchingProducts,
});

export function useProducts() {
  const {products, isFetchingProducts} = useSelector(
    productSelector,
    shallowEqual
  );

  return {
    products: products || [],
    isFetchingProducts,
  };
}

/* export function useProduct(id: string) {
  const {products} = useProducts();

  return products.find(product => product.id === id);
} */

type QueryFilter = {[key: string]: string | number};

const productActions = {
  fetchProducts: bulkEditActions.fetchBulkEditProducts,
  searchProducts: bulkEditActions.searchBulkEditProducts,
};

export function useFetchProducts() {
  const {fetchProducts} = useActions(productActions);
  const {filter} = useProductFilter();

  const getProducts = useCallback(
    (query?: QueryFilter) => {
      // $FlowFixMe
      const queryFilter: QueryFilter = {
        page: 0,
        size: 8,
        ...query,
      };

      if (filter.value.length === 0) {
        fetchProducts(queryFilter);
        return;
      }
      if (filter.type === 'category') {
        queryFilter.categories = filter.value.join(',');
      }

      if (filter.type === 'promotions') {
        queryFilter.promotions = filter.value.join(',');
      }

      if (filter.type === 'wholesale-price') {
        const [value] = filter.value;
        const queryFlag = value === 'active' ? 1 : 0;

        queryFilter.has_bulk_price = queryFlag;
      }

      if (filter.type === 'stock') {
        const [value] = filter.value;
        const queryFlag = value === 'active' ? 1 : 0;

        queryFilter.has_stock = queryFlag;
      }

      fetchProducts(queryFilter);
    },
    [fetchProducts, filter]
  );

  const addProducts = useCallback(
    (query?: QueryFilter) => {
      // $FlowFixMe
      const queryFilter: QueryFilter = {
        size: 8,
        ...query,
      };
      fetchProducts(queryFilter, true);
    },
    [fetchProducts]
  );

  return {getProducts, addProducts};
}

const productPagination = (state: RootState) => state.bulkEdit.pagination;

export function useProductPagination() {
  const pagination = useSelector(productPagination);

  return pagination;
}
